import { defineElement } from '@webtides/element-js';
import BaseSelectField from '../../../../legacy-library/webcomponents/_form/select-field/select-field.class';
import style from './select-field.css';

export default class SelectField extends BaseSelectField {
    constructor() {
        super({ styles: [style] });
    }
}

defineElement('select-field', SelectField);
